import React from 'react';
import { enumIconHeaderStepperComponent } from '../components/headerStepperComponent';
import { enumTypeInput } from '../components/inputComponent';
import { optionsSelectDropDown } from '../components/selectDropDown';
import IconExpediente from '../source/icons/expediente';
import IconDateVisit from '../source/icons/fecha-visita';
import IconMoney from '../source/icons/money';
import IconUser from '../source/icons/user';

export class billingOptionsStepperModel {
  id: number = 0;
  icon: enumIconHeaderStepperComponent  = enumIconHeaderStepperComponent.profile;
  title: string = '';
  form: billingOptionsStepperFormModel [] = [];
}
export class billingOptionsStepperFormModel {
  icon?: any = <IconDateVisit />;
  buttonLarge?: boolean = false;
  placeholder?: string = '';
  type?: enumTypeInput = enumTypeInput.text;
  value?: any = '';
  rowGroup?: billingOptionsStepperFormModel[] = [];
  style?: any = {};
  dropdown?:boolean = false;
  dropdownLarge?: boolean = false;
  options?: optionsSelectDropDown[] = [];
  buttonSmall?: boolean = false;
  title?: string = '';
  question?: any = '';
  id:string = '';
  maxHeight?: number = 200;
  disabled?:boolean = false;
  selected?:number;
  model?:any;
  upperCase?:boolean;
  withFilter?: boolean = false;
  required?: boolean = false;
  maxLength?: number = 0;
}
export const billingOptionsStepperItems = (styles:any):Array<billingOptionsStepperModel> => {
  const optionsGeneral: optionsSelectDropDown[] = [];
//  const optionsEstados: optionsSelectDropDown[] = [];
  return [
    {
    id: 0,
    icon: enumIconHeaderStepperComponent.profile,
    title: 'Datos de factura:',
    form: [{
      id: 'fechaVisita',
      icon: <IconDateVisit style={styles('iconItemGroupStep')} />,
      buttonLarge: false,
      title: 'Fecha de visita:',
      placeholder: '00 / 00 / 0000',
      type: enumTypeInput.date,
    }, {
      id: 'numeroVisita',
      icon: <IconUser style={styles('iconItemGroupStep')} />,
      buttonLarge: true,
      title: 'Número de visita:',
      type: enumTypeInput.number,
      placeholder: '00000000',
      question: 'noVisita',
      style: styles('columnReverse'),
    }, {
      id: 'expediente',
      icon: <IconExpediente style={styles('iconItemGroupStep')} />,
      buttonLarge: true,
      title: 'Expediente:',
      type: enumTypeInput.number,
      placeholder: '00000000',
      question: 'expediente',
      style: styles('columnReverse'),
    }, {
      id: 'montoTotal',
      icon: <IconMoney style={styles('iconItemGroupStep')} />,
      buttonLarge: false,
      title: 'Monto total:',
      type: enumTypeInput.decimal,
      placeholder: '0,000.00',
    }],
  }, {
    id: 1,
    icon: enumIconHeaderStepperComponent.file,
    title: 'Datos fiscales:',
    form: [
		{
			id: 'razonSocial',
			buttonLarge: true,
			title: 'Razón social:',
			type: enumTypeInput.text,
			placeholder: 'Nombre o razón social',
			question: 'razonSocial',
			upperCase: true,
		},
		{
			id: 'rfc',
			buttonLarge: true,
			title: 'RFC:',
			type: enumTypeInput.text,
			placeholder: 'RFC',
			question: 'rfc',
			upperCase: true,
			maxLength: 13,
		},
		{
			id: 'regimenFiscal',
			dropdown: true,
			title: 'Regimen Fiscal:',
			placeholder: 'Regimen fiscal',
			question: 'regimenFiscal',
			dropdownLarge: true,
			options: optionsGeneral,
			maxHeight: 180,
			withFilter: true,
		},
		{
			id: 'usoCFDI',
			dropdown: true,
			title: 'Uso CFDI:',
			placeholder: 'Gastos en general',
			dropdownLarge: true,
			options: optionsGeneral,
			maxHeight: 170,
			withFilter: true,
		},
		{
			id: '',
			rowGroup: [
				{
					id: 'codigoPostal',
					buttonSmall: true,
//             buttonLarge: false,
					title: 'C.P.:',
					type: enumTypeInput.number,
					placeholder: '00000',
					question: 'codigoPostal',
					maxLength: 5,
				},
				{
					id: 'colonia',
					buttonLarge: false,
					title: 'Colonia:',
					type: enumTypeInput.text,
					style: styles('colonia'),
					placeholder: 'Nombre de la colonia',
					required: false,
				},
			],
			style: styles('groupColonia'),
		},
		{
			id: '',
			rowGroup: [
				{
					id: 'calle',
					buttonLarge: false,
					title: 'Calle:',
					type: enumTypeInput.text,
					style: styles('calle'),
					placeholder: 'Nombre de la calle',
					required: false,
				},
			],
		},
		{
			id: '',
			rowGroup: [
				{
					id: 'numeroExterior',
					buttonSmall: true,
//             buttonLarge: true,
					title: 'No. Exterior:',
					type: enumTypeInput.text,
					style: styles('numeroExterior'),
					placeholder: '0000',
					required: false,
				},
				{
					id: 'numeroInterior',
//             buttonLarge: false,
					buttonSmall: true,
					title: 'No. Interior:',
					type: enumTypeInput.text,
					style: styles('numeroInterior'),
					placeholder: '00',
					required: false,
				},
			],
		},
		{
			id: 'municipio',
			buttonLarge: false,
			title: 'Delegación o municipio:',
			type: enumTypeInput.text,
			style: styles('municipio'),
			placeholder: 'Nombre de la delegación o municipio',
			required: false,
			disabled: true,
		},
//	   {
//      id: 'estado',
//      dropdown: true,
//      title: 'Estado:',
//      placeholder: 'CDMX',
//      dropdownLarge: true,
//      options: optionsEstados,
//      disabled: true,
//      withFilter: true,
//	   },
		{
			id: 'estado',
			buttonLarge: false,
			title: 'Estado:',
			type: enumTypeInput.text,
			style: styles('estado'),
			placeholder: 'CDMX',
			required: false,
			disabled: true,
 //      options: optionsEstados,
		},
		{
			id: '',
			rowGroup: [
				{
					id: 'telefono',
//             buttonLarge: true,
					buttonSmall: true,
					title: 'Telefono:',
					type: enumTypeInput.number,
					style: styles('telefono'),
					placeholder: '5555555555',
					required: false,
					maxLength: 10,
				},
				{
					id: 'extension',
					buttonSmall: true,
					title: 'Ext:',
					type: enumTypeInput.number,
					placeholder: '00000',
					required: false,
					maxLength: 5,
				}],
				style: styles('groupLada'),
			}],
		}];
};
